module.exports = __webpack_public_path__ + "static/img/roomImg2.bb5fad9d.png";